export default "__VITE_ASSET__CVNOod_g__"